exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Photos-10590c0a{margin:-7px -10px;display:flex;flex-wrap:wrap}.Photos-10590c0a .photo-a5cb25fd{flex:1 1 calc(25% - 20px);margin:7px 10px;font-size:0px;line-height:0px}@media screen and (max-width: 530px){.Photos-10590c0a{margin:-3px -4px}.Photos-10590c0a .photo-a5cb25fd{margin:4px 4px}}.Photos-10590c0a .photo-a5cb25fd img{width:100%;height:auto;max-width:295px;max-height:295px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"Photos": "Photos-10590c0a",
	"photo": "photo-a5cb25fd"
};